import React from "react";
import { useTranslation } from "react-i18next";
const CustomBanner = ({ bannerdata }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="koze_home_slider">
                {bannerdata.map((items, index) => (
                    <div key={index} style={{ position: "relative" }}>
                        <div
                            style={{ color: "white" }}
                            className="font-30 Helvetica absolute z-10 h-full w-full flex justify-center items-center "
                        >
                            <div className="px-8">
                                <h1
                                    className="cinzel font-75 font-semibold text-center capitalize"
                                >
                                    {t(items.Name)}
                                    <br /><span className='showbr'></span>
                                    {t(items.NameTwo)}
                                </h1>
                                {items.Title === "" ? <div className="hidden"></div> :
                                    <div className="flex gap-4 m-auto justify-center items-center mt-9">
                                        <div
                                            style={{ textAlign: "center", fontSize: "20px" }}
                                            className="font-30 Optima"
                                        >
                                            {t(items.Title)}
                                            <br /><span className='showbr'></span>
                                            {t(items.TitleTwo)}
                                        </div>
                                    </div>}
                            </div>
                        </div>
                        <img
                            src={items.Bannerimg}
                            className=" object-cover"
                            style={{ width: "100%", height: "auto", filter: "brightness(0.6) " }}
                        />
                        <img src={items.BottomImg} className="absolute -bottom-[1px] w-full" />
                    </div>
                ))}
            </div>
        </div>
    )

}
export default CustomBanner;